{
  "views": {
    "Account": "Account",
    "Analytes": "Analytes",
    "ApiKeys": "API Keys",
    "AreaGrants": "Zone Access",
    "BlastFiring": "Firing",
    "BlastHoleDrilling": "Add/Edit Blast Hole Drilling",
    "BlastHoleDrillingList": "Blast Hole Drilling List",
    "BlastMaterial": "Materials",
    "BlastMaterialType": "Material Types",
    "BlastPattern": "Patterns",
    "BlastReference": "D&B References",
    "BucketFactors": "Bucket Factors",
    "BucketTypes": "Bucket Types",
    "DailyReport": "Daily Report",
    "DashboardTiles": "Dashboard Tiles",
    "Densities": "Densities",
    "DeviceMappings": "Device Mappings",
    "Dewatering": "Dewatering",
    "DiggingLoadingSummary": "Production List",
    "DowntimeSubtypes": "Downtime Subtypes",
    "DrillBlastSettings": "D&B Settings",
    "DrillConsumables": "Drill Consumables",
    "DrillConsumableStock": "Consumables Stock",
    "EditImportTemplate": "Edit Import Template",
    "ExplosivesRegister": "Explosives Register",
    "ExplosivesStore": "Explosives Store",
    "GeologyCrushing": "Crushing",
    "GeologyDrilling": "Drilling",
    "GeologyMilling": "Milling",
    "GeologyOreBlocks": "Ore Blocks",
    "GeologyOreTally": "Ore Tally",
    "GeologyRehandle": "Rehandle",
    "Home": "Home",
    "Locations": "Locations",
    "Login": "Login",
    "MachinePositions": "Machine Positions",
    "Magazines": "Magazines",
    "MaterialTypeClasses": "Material Type Classes",
    "MaterialTypes": "Material Types",
    "MinePeriods": "Mine Periods",
    "MiningEquipment": "Mining Equipment",
    "MiningMvtList": "Mining Mvt List",
    "MorningReport": "Morning Meeting Report",
    "NewImportTemplate": "New Import Template",
    "None": "None",
    "Operations": "Operations List",
    "Personnel": "Personnel",
    "PitStages": "Pit Stages",
    "Plants": "Plant",
    "PlantTypes": "Plant Types",
    "Production": "Add/Edit Production",
    "ProductionOreTally": "Ore Tally",
    "RcDrilling": "RC Drilling",
    "RecalculateStockpiles": "Recalculate Stockpiles",
    "ReportBuilder": "Eclipse Report Builder",
    "ReportDataConnections": "Data Connections",
    "ReportLibrary": "Report Library",
    "RoyaltyAreaBalances": "Royalty Area Balances",
    "RoyaltySplits": "Royalty Splits",
    "SectionNames": "Section Names",
    "ShowMiningMvt": "Show Mining Mvt",
    "StockpileBalances": "Stockpile Balances",
    "Stoppages": "Stoppages",
    "TargetImport": "Target Imports",
    "Targets": "Targets and EOM Actuals",
    "TargetTypes": "Target Types",
    "UncheckedGpsStoppages": "Unchecked GPS",
    "Users": "Users",
    "Zones": "Zones"
  },
  "sections": {
    "operations": "Operations",
    "stoppages": "Stoppages",
    "production": "Production",
    "db": "Drill & Blast",
    "geology": "Geology",
    "reports": "Reports",
    "royalty-splits": "Royalty Splits",
    "royalty-area-balances": "Royalty Area Balances",
    "admin": "Admin"
  }
}
